import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchInventoryUploads } from 'store/actions/index';
import * as Page from 'HOC/Layout/PageContainer';
import styles from './InventoryPage.module.css';
import UploadsTable from 'components/Inventory/UploadsTable';
import UploadModal from 'components/Inventory/UploadModal';

const { Container, Title } = Page;

class InventoryPage extends Component {
  state = {
    showUploadModal: false,
    pollIntervalID: null,
  };

  componentDidMount = () => {
    this.props.fetchInventoryUploads().then(this.startPollOnCheck);
  };

  // cancel the poll if it was set and the job is complete
  componentWillReceiveProps = (nextProps, nextState) => {
    if (this.props.uploads.length !== nextProps.uploads.length) {
      return;
    }
    if (this.state.pollIntervalID === null) {
      return;
    }
    const upload = this.props.uploads[0];
    if (!upload) {
      return;
    }
    if (upload.state === 'PROCESSED' || upload.state === 'ERROR') {
      this.stopPoll();
    }
  };

  componentWillUnmount = () => {
    this.stopPoll();
  };

  render = () => {
    const { loading, uploads, token, fetchInventoryUploads } = this.props;

    return (
      <Container type="2x3">
        <Title title="Inventory" button={true} onClick={this.toggleUploadModal} />
        <div className={styles.Main}>
          <UploadsTable loading={loading} uploads={uploads} />
          <UploadModal
            visible={this.state.showUploadModal}
            onCancel={this.toggleUploadModal}
            onOk={this.handleUploadFinished}
            token={token}
            fetchInventoryUploads={fetchInventoryUploads}
          />
        </div>
      </Container>
    );
  };

  toggleUploadModal = () => {
    this.setState(prev => ({ ...prev, showUploadModal: !this.state.showUploadModal }));
  };

  handleUploadFinished = () => {
    this.setState(prev => ({ ...prev, showUploadModal: false }));
    this.props.fetchInventoryUploads().then(() => {
      this.stopPoll();
      this.startPollOnCheck();
    });
  };

  startPollOnCheck = () => {
    const upload = this.props.uploads[0];
    if (!upload) {
      return;
    }
    if (upload.state === 'NEW' || upload.state === 'PROCESSING') {
      console.log('starting poll');
      const intervalID = setInterval(this.props.fetchInventoryUploads, 5000);
      this.setState(prev => ({ ...prev, pollIntervalID: intervalID }));
    }
  };

  stopPoll = () => {
    if (this.state.pollIntervalID !== null) {
      console.log('stopping poll');
      clearInterval(this.state.pollIntervalID);
    }
  };
}

const mapStateToProps = state => {
  const { loading, uploads } = state.inventory;
  const { token } = state.auth;

  return {
    loading,
    uploads,
    token,
  };
};

const mapDispatchToProps = {
  fetchInventoryUploads,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(InventoryPage);



// WEBPACK FOOTER //
// ./src/containers/Inventory/InventoryPage.js